import { LunaTabName } from "@/types";

import Diagrams from "./Diagrams";
import Examples from "./Examples";
import LessonPlan from "./LessonPlan";
import Problems from "./Problems";
import Solutions from "./Solutions";
import StudentProfile from "./StudentProfile";

interface TabContentProps {
  activeTab: LunaTabName;
}

const TabContent = ({ activeTab }: TabContentProps) => {
  return (
    <div style={{ height: "100%" }}>
      <div
        style={{
          display: activeTab === LunaTabName.Problems ? "flex" : "none",
          height: "100%",
        }}
      >
        <Problems />
      </div>
      <div
        style={{
          display: activeTab === LunaTabName.Solutions ? "flex" : "none",
          height: "100%",
        }}
      >
        <Solutions />
      </div>
      <div
        style={{
          display: activeTab === LunaTabName.Examples ? "block" : "none",
          height: "100%",
        }}
      >
        <Examples />
      </div>
      <div
        style={{
          display: activeTab === LunaTabName.Diagrams ? "block" : "none",
          height: "100%",
        }}
      >
        <Diagrams />
      </div>
      <div
        style={{
          display: activeTab === LunaTabName.StudentProfile ? "block" : "none",
          height: "100%",
        }}
      >
        <StudentProfile />
      </div>
      <div
        style={{
          display: activeTab === LunaTabName.LessonPlan ? "block" : "none",
          height: "100%",
        }}
      >
        <LessonPlan />
      </div>
    </div>
  );
};

export default TabContent;
